import { render } from "./ConceptDecorationWidget.vue?vue&type=template&id=1d28924b&scoped=true"
import script from "./ConceptDecorationWidget.vue?vue&type=script&lang=js"
export * from "./ConceptDecorationWidget.vue?vue&type=script&lang=js"

import "./ConceptDecorationWidget.vue?vue&type=style&index=0&id=1d28924b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d28924b"]])

export default __exports__